<template>
	<div id="resultPbulicNotice" class="result-public-notice">
		<search-panel :searchdata="searchdata" :showBtn="showBtn" @passLimit="getLimit" :dirs="dirs"></search-panel>
        <div style="margin:0 5px 5px;">
            <el-table :data="tableData" @current-change="(val)=>{currentRow=val}" @sort-change="sortChange" v-loading="loading" element-loading-text="加载中，请稍候" highlight-current-row border style="width:100%;">
                <el-table-column prop="publicitybh" label="公示书编号" sortable>
                    <template scope="scope">
                        <a href="javascript:void(0)" @click="queryItem(scope.row)">{{scope.row.publicitybh}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="conunitmc" label="施工单位" sortable></el-table-column>
                <el-table-column prop="quallevel" label="企业资质等级" sortable>
                    <template scope="scope">
                        {{ scope.row[scope.row.id] }}
                    </template>
                </el-table-column>
                <el-table-column prop="totalname" label="所在地" sortable></el-table-column>
                <el-table-column prop="licensenumber" label="安全生产许可证号" sortable></el-table-column>
                <el-table-column prop="finalresult" label="考评结果" sortable></el-table-column>
                <el-table-column prop="publicitystadate" label="公示起始时间" sortable>
                    <template scope="scope">{{scope.row.publicitystadate | parse_date}}</template>
                </el-table-column>
                <el-table-column prop="publicitydate" label="公示截止时间" sortable>
                    <template scope="scope">{{scope.row.publicitydate | parse_date}}</template>
                </el-table-column>
            </el-table>
        </div>
		<pagination @paginationChange="paginationChange" :total="totalPage"></pagination>
	</div>
</template>
<script>
import { validateDateRange } from "@/tool/parse.js"
import { resultPbulicNotice } from "@/assets/json.js"
import { Dictionaries } from "@/resources.js"
import { parse_date } from "@/tool/parse.js"

import searchPanel from "@/components/common/search_panel_new.vue"
import baseTable from "@/components/common/base_table.vue"
import pagination from "@/components/common/pagination.vue"
import { API_SecSeal, API_UnitCheck, API_Common } from "@/api/api.js"
import JS_secSeal from "@/tool/secSeal.js" //签章JS

export default {
	props: ['isIndex'],
	data() {
		return {
			searchdata: searchdata,
			showBtn: showBtn,
			dirs: {
				"qualLevel": qualLevel,
				"totalname": totalname,
				"evalresultEtp": evalresultEtp,
			},
			limit: {},
			// table_init: resultPbulicNotice.table_init,
			tableData: [],
			loading: false,
			totalPage: 0,
			page: 1,
			pageSize: 10,
			currentRow: {},
			sort: "publicitybh",
			order: "asc",
			// 字典loading
			dicIndex: 0,
			dateLen: 0,
		}
	},
	mounted() {
		this.queryAll();
	},
	watch: {
		dicIndex() {
			if (this.dicIndex == this.dateLen) {
				this.loading = false;
			}
		},
	},
	methods: {
		getLimit(params) {
			switch (params[0]) {
				case "queryAll":
					{
						let t_limit = params[1];
						let limit = {};
						for (var i in t_limit) {
							if (typeof t_limit[i] == "object") {//el-datepicker返回的日期对象
								let dateStr = new Date(t_limit[i]);
								if (isNaN(dateStr.getDate())) { continue; }
								else {
									let year = dateStr.getFullYear();
									let month = dateStr.getMonth() + 1;
									let date = dateStr.getDate();
									limit[i] = year + "-" + (month >= 10 ? month : "0" + month) + "-" + (date >= 10 ? date : "0" + date);
								}
							}
							else if (t_limit[i] && t_limit[i].length > 0) {
								limit[i] = t_limit[i];
							}
						}
						this.limit = limit;
					}
					this.queryAll();
					break;
			}
		},
		sortChange(param) {
			if (param.order != null) {
				this.order = param.order.indexOf("asc") > -1 ? "asc" : "desc";
				this.sort = param.prop;
				this.queryAll();
			}
		},
		paginationChange(param) {
			this.pageSize = param[0];
			this.page = param[1];
			this.queryAll();
		},
		queryAll() {
			if (!validateDateRange(this.limit.publicitystadate, this.limit.publicitydate, this, "公示期限起始日期 应小于 截止日期")) { return; }

			this.tableData = [];
			this.dicIndex = 0;
			this.loading = true;
			let limit = {};
			for (let i in this.limit) { limit[i] = this.limit[i]; }
			limit[this.sort + "_order"] = this.order;
			if (this.isIndex) {
				API_UnitCheck.homeListResultPublic(this.pageSize + "/" + this.page, { limit: limit }).then(res => {
					let me = this;
					this.dateLen = res.resultList.length;
					res.resultList.forEach(v => {
						v[v.id] = "";
						API_Common.getQualityDic({ limit: { unit_quality: v.quallevel, unit_level: v.qualGrade } }).then(dic => {
						v[v.id] = dic;
						me.dicIndex++;
					})
						// API_Common.getDic({ limit: { "dictTypeId": "unit_quality", "dictId": v.quallevel } }).then(res1 => {
						// 	API_Common.getDic({ limit: { "dictTypeId": "unit_level", "dictId": v.qualGrade } }).then(res2 => {
						// 		v[v.id] = res1 + res2;
						// 		me.dicIndex++;
						// 	})
						// })
						this.tableData.push(v);
					})
					if (this.dateLen == 0) {
						this.loading = false;
					}
					this.totalPage = res.count;
				})
			}
			else {
				API_UnitCheck.listResultPublic(this.pageSize + "/" + this.page, { limit: limit }).then(res => {
					let me = this;
					this.dateLen = res.data.length;
					res.data.forEach(v => {
						v[v.id] = "";
						API_Common.getQualityDic({ limit: { unit_quality: v.quallevel, unit_level: v.qualGrade } }).then(dic => {
						v[v.id] = dic;
						me.dicIndex++;
					})
						// API_Common.getDic({ limit: { "dictTypeId": "unit_quality", "dictId": v.quallevel } }).then(res1 => {
						// 	API_Common.getDic({ limit: { "dictTypeId": "unit_level", "dictId": v.qualGrade } }).then(res2 => {
						// 		v[v.id] = res1 + res2;
						// 		me.dicIndex++;
						// 	})
						// })
						this.tableData.push(v);
					})
					if (this.dateLen == 0) {
						this.loading = false;
					}
					this.totalPage = res.total;
				})
			}
		},
		queryItem(row) {
			this.currentRow = row;
			JS_secSeal.onload(this,true);
			API_SecSeal.getList("20/1/", { limit: { recordId: this.currentRow.id, code: "SGXMKP004" , tableName:"HY_SAFETY_UNITEVALUATIONSP" } }).then(res => {
				if (res.total > 0) {
					JS_secSeal.viewSeal(res.data[0].filepath, (res.data[0].type ? res.data[0].type === "getFromSupervisorEnd" : false),true);
				} else {
					this.$notify({
						message: "无可展示的签章文件，请先盖章保存。",
						type: "info",
						offset: document.body.clientHeight - 200, duration: 2000
					});
				}
			})
		},
	},
	filters: {
		parse_date: parse_date
	},
	components: { searchPanel, baseTable, pagination }
}
var showBtn = [
	{ "label": "搜索", attr: "queryAll" },
];
var searchdata = [
	{ name: "施工企业名称", attr: "conunitmc_like", type: "text", isRange: false, "dictionary": "" },
	{ name: "企业资质等级", attr: "quallevel", type: "qualLevel" },
	// {name:"企业资质等级",attr:"aptitudeLevel",type:"dialog",isRange:false,"dictionary":"",children:{attrName:"quallevalmc",attrId:"quallevalid"}},
	{ name: "所在地", attr: "totalname", type: "select", isRange: false, "dictionary": "totalname" },
	{ name: "安全生产许可证号", attr: "licensenumber", type: "text", isRange: false, "dictionary": "" },
	{ name: "考评结果", attr: "finaltrialresult", type: "select", isRange: false, "dictionary": "evalresultEtp" },
	{ name: "公示书编号", attr: "publicitybh", type: "text", isRange: false, "dictionary": "" },
	{ name: "公示期限", attr: "publicitydate", type: "date", isRange: true, "dictionary": "", children: { startAttr: "publicitystadate", endAttr: "publicitydate" } },
];
const totalname = [{ name: "全部", code: "" }, { name: "福州市", code: "福州市" }, { name: "厦门市", code: "厦门市" }, { name: "泉州市", code: "泉州市" },
{ name: "漳州市", code: "漳州市" }, { name: "莆田市", code: "莆田市" }, { name: "宁德市", code: "宁德市" }, { name: "龙岩市", code: "龙岩市" },
{ name: "三明市", code: "三明市" }, { name: "南平市", code: "南平市" }, { name: "平潭综合实验区", code: "平潭综合实验区" }];
const evalresultEtp = [{ name: "全部", code: "" }, { name: "合格", code: "合格" }, { name: "基本合格", code: "基本合格" }, { name: "不合格", code: "不合格" },];
const qualLevel = {
	"grade": [{ code: "1", name: "建筑工程施工总承包" }, { code: "2", name: "市政公用工程施工总承包" }, { code: "3", name: "地基基础工程专业承包" }, { code: "4", name: "起重设备安装工程专业承包" }, { code: "5", name: "预拌混凝土专业承包" }, { code: "6", name: "电子与智能化工程专业承包" }, { code: "7", name: "消防设施工程专业承包" }, { code: "8", name: "防水防腐保温工程专业承包" }, { code: "9", name: "桥梁工程专业承包" }, { code: "10", name: "隧道工程专业承包" }, { code: "11", name: "钢结构工程专业承包" }, { code: "12", name: "模板脚手架专业承包" }, { code: "13", name: "建筑装修装饰工程专业承包" }, { code: "14", name: "建筑机电安装工程专业承包" }, { code: "15", name: "建筑幕墙工程专业承包" }, { code: "16", name: "古建筑工程专业承包" }, { code: "17", name: "城市及道路照明工程专业承包" }, { code: "18", name: "施工劳务" }],
	"level": [{ code: "1", name: "特级" }, { code: "2", name: "一级" }, { code: "3", name: "二级" }, { code: "4", name: "三级" }, { code: "5", name: "不分等级" }, { code: "6", name: "不分类别和等级" }],
};
</script>



// WEBPACK FOOTER //
// resultPublicNotice.vue?6b2dfef6